import { render, staticRenderFns } from "./SubmitHandover.vue?vue&type=template&id=23ff4764&scoped=true&"
import script from "./SubmitHandover.vue?vue&type=script&lang=js&"
export * from "./SubmitHandover.vue?vue&type=script&lang=js&"
import style0 from "./SubmitHandover.vue?vue&type=style&index=0&id=23ff4764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ff4764",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23ff4764')) {
      api.createRecord('23ff4764', component.options)
    } else {
      api.reload('23ff4764', component.options)
    }
    module.hot.accept("./SubmitHandover.vue?vue&type=template&id=23ff4764&scoped=true&", function () {
      api.rerender('23ff4764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/hotb/SubmitHandover.vue"
export default component.exports